export const scrollTo = (
  element: string | Element | null,
  offset: number = 0
) => {
  if (typeof element === "string") {
    element = document.querySelector(element)
  }

  if (element) {
    element.scrollTo({ top: offset, behavior: "smooth" })
  }
}
